<template>
  <b-container>
    <b-row>
      <h4 class="mt-3 ml-0">{{ $t("workflow.stageProcess") }}</h4>
    </b-row>
    <b-row>
      <b-table-simple hover small caption-top responsive>
        <b-thead>
          <b-tr>
            <b-th v-for="field in stageField" :key="field.key">
              {{ field.label }}
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <template v-for="row in fillActiveList">
            <!-- {{ row.stage }} -->
            <!-- {{ row.stage.sequenceNumber }} -->
            <b-tr :key="row.stage.sequenceNumber">
              <b-td> {{ row.stage.sequenceNumber }} </b-td>
              <b-td> {{ row.stage.displayName }} </b-td>

              <b-td style="min-width: 250px">
                <!-- <stage-edit-modal :stage="row.stage"></stage-edit-modal> -->
                <stage-modal
                  class="d-inline"
                  :process="process"
                  :stage.sync="row.stage"
                  :tableRows="tableRows"
                ></stage-modal>
                <stage-table-resequence
                  class="d-inline ml-1"
                  :item="row.stage"
                  :items="stages"
                  :display-name="row.stage.displayName"
                  v-b-tooltip.hover
                ></stage-table-resequence>
                <b-button
                  class="ml-1"
                  size="sm"
                  :title="$t('checklist.form.fieldDelete')"
                  v-b-tooltip.hover
                  @click="deleteStage(row)"
                >
                  X
                </b-button>
                <b-button
                  size="sm"
                  class="ml-1"
                  :title="$t('checklist.form.fieldClone')"
                  v-b-tooltip.hover
                  @click="cloneField(row.stage, stages)"
                >
                  <i class="tim-icons icon-single-copy-04"></i>
                </b-button>
                <b-button
                  size="sm"
                  class="ml-1"
                  v-b-tooltip.hover
                  @click="
                    $bvModal.show(
                      `modal-next-stages-${row.stage.sequenceNumber}`
                    )
                  "
                >
                  <!-- <span class="material-icons" style="font-size: 15px">
                    rebase_edit
                  </span> -->
                  <!-- <i class="material-icons-outlined">account_tree</i> -->
                  <i class="tim-icons icon-bullet-list-67"></i>
                </b-button>
                <b-button
                  size="sm"
                  class="ml-1"
                  title="Script"
                  v-b-tooltip.hover
                  @click="openScriptModal(row.stage)"
                  :disabled="!isMasterAdmin"
                >
                  <i class="tim-icons icon-settings-gear-63"></i
                ></b-button>
              </b-td>
              <b-modal
                :id="`modal-next-stages-${row.stage.sequenceNumber}`"
                ref="modalNextStages"
                :title="
                  `${row.stage.displayName} - ${$t('workflow.nextStages')}`
                "
                size="xl"
              >
                <stage-crud-next-stages
                  :process="process"
                  :stage="row.stage"
                  :availableStages="stages"
                >
                </stage-crud-next-stages>
              </b-modal>
            </b-tr>
            <!-- <b-tr class="b-table-details" v-if="row.configShowing">
              <b-td :colspan="stageField.length">
                <b-card>
                  <b-row>
                    <b-col sm="12" md="12">
                      <stage-crud-next-stages
                        :process="process"
                        :stage="row.stage"
                        :availableStages="stages"
                      >
                      </stage-crud-next-stages>
                    </b-col>
                  </b-row>

                  ivan 20220812
                  <b-form-group
                    :label="$t('workflow.stage.scriptPosProcess')"
                    label-for="displayName"
                  >
                    <b-form-textarea
                      id="ScriptPythonValidation"
                      v-model="row.stage.scriptPython"
                      style="height: 10rem"
                    />
                  </b-form-group> --ivan 20220812>

                  <! -- ivan 20220812
                  <b-form-group
                    :label="$t('workflow.stage.scriptValidation')"
                    label-for="displayName"
                  >
                    <b-form-textarea
                      id="ScriptPythonValidation"
                      v-model="row.stage.validationScript"
                      style="height: 10rem"
                    />
                  </b-form-group> --ivan 20220812>
                </b-card>
              </b-td>
            </b-tr> -->
          </template>
        </b-tbody>
      </b-table-simple>
    </b-row>
    <stage-script-modal ref="scriptPython"></stage-script-modal>
    <stage-modal
      :process="process"
      :stages="stages"
      :tableRows="tableRows"
    ></stage-modal>
    <!-- <pre class="language-json"><code>{{ stages  }}</code></pre> -->
    <!-- {{ stages }} -->
    <!-- {{ tableRows }} -->
  </b-container>
</template>
<script>
import StageCloneField from "../Stage/StageCloneField";
export default {
  name: "StageCrud",
  components: {
    StageCrudNextStages: () =>
      import("@/components_rms/workflow/StageCrud/StageCrudNextStages.vue"),
    StageModal: () => import("@/components_rms/workflow/Stage/StageModal.vue"),
    StageTableResequence: () =>
      import("@/components_rms/workflow/Stage/StageTableResequence.vue"),
    StageScriptModal: () =>
      import("@/components_rms/workflow/Stage/StageScriptModal.vue")
  },
  props: {
    process: Object,
    stages: Array
  },
  mixins: [StageCloneField],
  created() {
    this.getUserMaster();
  },
  data() {
    return {
      isMasterAdmin: false,
      tableRows: [],
      stageField: [
        {
          label: "Id",
          key: "sequenceNumber",
          sortable: false
        },
        {
          label: "Nome",
          key: "displayName",
          sortable: false
        },
        {
          key: "actions",
          label: ""
        }
      ],
      nextStageOptions: []
    };
  },
  computed: {
    fillActiveList() {
      let camposAtivos = [];
      for (let campo of this.tableRows) {
        if (campo.stage.active) {
          camposAtivos.push(campo);
        }
      }
      return camposAtivos;
    }
  },
  // created(){
  //   this.loadTableRows();
  // },
  mounted: function() {
    this.loadTableRows();
  },
  methods: {
    openScriptModal(row) {
      this.$refs.scriptPython.show(row);
    },
    getUserMaster() {
      this.$apiScheduler
        .get("/module/getUserMaster/")
        .then(response => {
          this.isMasterAdmin = response.data;
        })
        .catch(error => {
          console.log(error);
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    addTableRow(stage) {
      this.tableRows.push({
        configShowing: false,
        detailsShowing: false,
        stage: stage
      });
    },
    deleteStage(row) {
      if (!row.stage.id || row.stage.id == 0) {
        let rowIndex = this.tableRows.indexOf(row);
        if (rowIndex >= 0) {
          this.tableRows.splice(rowIndex, 1);
        }

        let itemIndex = this.stages.indexOf(row.stage);
        if (itemIndex >= 0) {
          this.stages.splice(itemIndex, 1);
        }
      } else {
        row.stage.active = false;
      }
      // reordenação da sequenciaExibicao após remover o campo
      let campos = this.fillActiveList;
      for (let i = 0; i < campos.length; i++) {
        campos[i].stage.sequenceNumber = i + 1;
      }
    },
    cloneField(campoBase, listaCampos) {
      this.copyField(campoBase, listaCampos);
      this.$forceUpdate();
    },
    loadTableRows() {
      this.tableRows = [];
      if (this.stages) {
        if (this.stages.length > 0) {
          this.stages.forEach(field => {
            this.addTableRow(field);
          });
        }
      }
      this.$forceUpdate();
    },
    displayConfig(row) {
      if (row) {
        row.configShowing = !row.configShowing;
        this.$forceUpdate();
      }
    },
    addStageOption() {
      this.stages.forEach(stage => {
        this.nextStageOptions.push({
          value: stage.id,
          text: stage.displayName
        });
      });
    }
  },
  watch: {
    stages() {
      this.loadTableRows();
      this.addStageOption();
    }
  }
};
</script>
